export default "__VITE_ASSET__DQPD6Wwk__"